/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Tutorial_LabelInputs */

const en_camera_tutorial_label = /** @type {(inputs: Camera_Tutorial_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera controls`)
};

const fr_camera_tutorial_label = /** @type {(inputs: Camera_Tutorial_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilotage caméra`)
};

const ms_sg2_camera_tutorial_label = /** @type {(inputs: Camera_Tutorial_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kawalan kamera`)
};

/**
* | output |
* | --- |
* | "Camera controls" |
*
* @param {Camera_Tutorial_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const camera_tutorial_label = /** @type {((inputs?: Camera_Tutorial_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Tutorial_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_camera_tutorial_label(inputs)
	if (locale === "fr") return fr_camera_tutorial_label(inputs)
	return ms_sg2_camera_tutorial_label(inputs)
});